// import { db, storage } from "../../firebase";
// import {
//   Timestamp,
//   deleteDoc,
//   doc,
//   setDoc,
//   updateDoc,
// } from "firebase/firestore";
// import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

// export const createNewItem = async ({
//   data,
//   image,
//   pdfFile,
//   collectionName = "posts",
// }) => {
//   if (!data?.title) {
//     throw new Error("Title is undefined");
//   }
//   if (!data?.slug) {
//     throw new Error("Slug is undefined");
//   }

//   let imageURL = "";
//   if (image) {
//     const imageRef = ref(storage, `${collectionName}/${data?.slug}.png`);
//     await uploadBytes(imageRef, image);
//     imageURL = await getDownloadURL(imageRef);
//   } else if (collectionName === "posts") {
//     throw new Error("Image is not selected for post");
//   }

//   let pdfURL = "";
//   if (collectionName === "magazines" && pdfFile) {
//     const pdfRef = ref(storage, `magazines/${data?.slug}.pdf`);
//     await uploadBytes(pdfRef, pdfFile);
//     pdfURL = await getDownloadURL(pdfRef);
//   } else if (collectionName === "magazines" && !pdfFile) {
//     throw new Error("PDF is not selected for magazine");
//   }

//   const firestoreRef = doc(db, collectionName, data.slug);
//   await setDoc(firestoreRef, {
//     ...data,
//     id: data.slug,
//     imageURL: imageURL || null,
//     pdfURL: pdfURL || null,
//     timestamp: data?.timestamp || Timestamp.now(),
//   });
// };

// export const updateItem = async ({
//   data,
//   image,
//   pdfFile,
//   collectionName = "posts",
// }) => {
//   if (!data?.title) {
//     throw new Error("Title is undefined");
//   }
//   if (!data?.slug) {
//     throw new Error("Slug is undefined");
//   }
//   if (!data?.id) {
//     throw new Error("ID is undefined for update");
//   }

//   let imageURL = data?.imageURL || "";
//   if (image) {
//     const imageRef = ref(storage, `${collectionName}/${data?.slug}.png`);
//     await uploadBytes(imageRef, image);
//     imageURL = await getDownloadURL(imageRef);
//   }

//   let pdfURL = data?.pdfURL || "";
//   if (collectionName === "magazines" && pdfFile) {
//     const pdfRef = ref(storage, `magazines/${data?.slug}.pdf`);
//     await uploadBytes(pdfRef, pdfFile);
//     pdfURL = await getDownloadURL(pdfRef);
//   }

//   const firestoreRef = doc(db, collectionName, data.id);
//   await updateDoc(firestoreRef, {
//     ...data,
//     imageURL: imageURL || null,
//     pdfURL: pdfURL || null,
//     timestamp: data?.timestamp || Timestamp.now(),
//   });
// };

// export const deleteItem = async (id, collectionName = "posts") => {
//   if (!id) {
//     throw new Error("Id is required");
//   }
//   const firestoreRef = doc(db, collectionName, id);
//   await deleteDoc(firestoreRef);
// };


import { db, storage } from "../../firebase";
import {
  Timestamp,
  deleteDoc,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  deleteObject,
} from "firebase/storage"; // Add deleteObject

export const createNewItem = async ({
  data,
  image,
  pdfFile,
  collectionName = "posts",
}) => {
  if (!data?.title) {
    throw new Error("Title is undefined");
  }
  if (!data?.slug) {
    throw new Error("Slug is undefined");
  }

  let imageURL = "";
  if (image) {
    const imageRef = ref(storage, `${collectionName}/${data?.slug}.png`);
    await uploadBytes(imageRef, image);
    imageURL = await getDownloadURL(imageRef);
  } else if (collectionName === "posts") {
    throw new Error("Image is not selected for post");
  }

  let pdfURL = "";
  if (collectionName === "magazines" && pdfFile) {
    const pdfRef = ref(storage, `magazines/${data?.slug}.pdf`);
    await uploadBytes(pdfRef, pdfFile);
    pdfURL = await getDownloadURL(pdfRef);
  } else if (collectionName === "magazines" && !pdfFile) {
    throw new Error("PDF is not selected for magazine");
  }

  const firestoreRef = doc(db, collectionName, data.slug);
  await setDoc(firestoreRef, {
    ...data,
    id: data.slug,
    imageURL: imageURL || null,
    pdfURL: pdfURL || null,
    timestamp: data?.timestamp || Timestamp.now(),
  });
};

export const updateItem = async ({
  data,
  image,
  pdfFile,
  collectionName = "posts",
}) => {
  if (!data?.title) {
    throw new Error("Title is undefined");
  }
  if (!data?.slug) {
    throw new Error("Slug is undefined");
  }
  if (!data?.id) {
    throw new Error("ID is undefined for update");
  }

  let imageURL = data?.imageURL || "";
  if (image) {
    const imageRef = ref(storage, `${collectionName}/${data?.slug}.png`);
    await uploadBytes(imageRef, image);
    imageURL = await getDownloadURL(imageRef);
  }

  let pdfURL = data?.pdfURL || "";
  if (collectionName === "magazines" && pdfFile) {
    const pdfRef = ref(storage, `magazines/${data?.slug}.pdf`);
    await uploadBytes(pdfRef, pdfFile);
    pdfURL = await getDownloadURL(pdfRef);
  }

  const firestoreRef = doc(db, collectionName, data.id);
  await updateDoc(firestoreRef, {
    ...data,
    imageURL: imageURL || null,
    pdfURL: pdfURL || null,
    timestamp: data?.timestamp || Timestamp.now(),
  });
};

export const deleteItem = async (id, collectionName = "posts") => {
  if (!id) {
    throw new Error("Id is required");
  }

  // Define Storage references
  const imageRef = ref(storage, `${collectionName}/${id}.png`);
  const pdfRef =
    collectionName === "magazines" ? ref(storage, `magazines/${id}.pdf`) : null;

  // Delete files from Storage
  try {
    // Delete image (all posts/magazines have an image)
    await deleteObject(imageRef);
    console.log(`Deleted image: ${collectionName}/${id}.png`);
  } catch (error) {
    if (error.code === "storage/object-not-found") {
      console.log(`Image not found: ${collectionName}/${id}.png, skipping...`);
    } else {
      console.error(`Error deleting image: ${error.message}`);
      throw error; // Re-throw if it's not a "not found" error
    }
  }

  // Delete PDF (only for magazines)
  if (collectionName === "magazines" && pdfRef) {
    try {
      await deleteObject(pdfRef);
      console.log(`Deleted PDF: magazines/${id}.pdf`);
    } catch (error) {
      if (error.code === "storage/object-not-found") {
        console.log(`PDF not found: magazines/${id}.pdf, skipping...`);
      } else {
        console.error(`Error deleting PDF: ${error.message}`);
        throw error;
      }
    }
  }

  // Delete Firestore document
  const firestoreRef = doc(db, collectionName, id);
  await deleteDoc(firestoreRef);
  console.log(`Deleted Firestore document: ${collectionName}/${id}`);
};